import {
    StorageType,
    OkrSessionStartType,
    OkrSessionDurationType,
    OkrCadenceType,
} from "client/utils"

export type ChangeAccountSettings = { [settingId: string]: any }

export interface AccountSettings {
    drive: {
        imageType: string
        fileType: string
        defaultStorage: StorageType
        googleDriveConnected: boolean
        microsoftDriveConnected: boolean
    }
    project: {
        defaultGroupsAssigned: boolean
    }
    cc: {
        defaultLibraryAssigned: boolean
        defaultResponsesAssigned: boolean
        defaultRequirementsPriorityAssigned: boolean
        defaultRequirementsReviewMethodAssigned: boolean
        defaultRequirementsSmartComplianceAssigned: boolean
        defaultRequirementsStatusAssigned: boolean
        defaultRequirementsTypeAssigned: boolean
        defaultReviewItemTypesAssigned: boolean
    }
    lifecycle: {
        defaultLifecyclesAssigned: boolean
    }
    sil: {
        defaultAssumption: string
    }
    okr: {
        defaultMetricsAssigned: boolean
        defaultSessionStartDate: OkrSessionStartType
        defaultSessionDuration: OkrSessionDurationType
        defaultSessionCadence: OkrCadenceType
    }
    rrs: {
        defaultCategoriesAssigned: boolean
        defaultTemplatesAssigned: boolean
    }
    study: {
        studyFields: {
            description: boolean
            manager: boolean
            systemStage: boolean
            studyStatus: boolean
            location: boolean
            site: boolean
            plant: boolean
            group: boolean
            unit: boolean
            subUnit: boolean
        }
        teamMembersFields: {
            company: boolean
            title: boolean
            department: boolean
            competence: boolean
            phone: boolean
            email: boolean
            comments: boolean
        }
        sessionFields: {
            facilitator: boolean
            scribe: boolean
            comment: boolean
        }
    }
}

export interface AccountSettingsState {
    settings: AccountSettings
}

export const SET_ACCOUNT_SETTINGS = "SET_ACCOUNT_SETTINGS"
export const UPDATE_ACCOUNT_SETTINGS = "UPDATE_ACCOUNT_SETTINGS"
